module.exports = __webpack_public_path__ + "static/img/10areaA_08.ff00d7d.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/10areaA_08.png
// module id = 889
// module chunks = 1